export default __webpack_public_path__ + "static/media/home.28f2acb2.jpeg";